import React, { useEffect, useLayoutEffect } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { KbArticle } from "../components/KbArticle";
import { loadKbArticle } from "../actions/kbActions";
import { Error, Loading } from "@a0/support-center-components";
import Breadcrumb from "../../common/components/Breadcrumb";

export const KbArticlePage = (props) => {
  const { loadKbArticle, params, loading, kbArticleRecord, notFound, error } = props;
  const { article } = params;

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [article]);

  useEffect(
    function () {
      loadKbArticle(article);
    },
    [article, loadKbArticle]
  );
  return (
    <div className="kb">
      <div className="bg-dots page-header-dots">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Knowledge Article</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <div className="container">
        <Loading show={loading}>
          {error && <Error message={error} />}
          {kbArticleRecord && <KbArticle kbArticle={kbArticleRecord} />}
          {notFound && <Error message="The requested article doesn't exist" />}
        </Loading>
      </div>
    </div>
  );
};

KbArticlePage.propTypes = {
  params: PropTypes.object,
  loadKbArticle: PropTypes.func,
  kbArticleRecord: PropTypes.object,
  loading: PropTypes.bool,
  notFound: PropTypes.bool,
  error: PropTypes.string
};

function mapStateToProps(state) {
  return {
    kbArticleRecord: state.kbArticle.record,
    loading: state.kbArticle.loading,
    error: state.kbArticle.error,
    notFound: state.kbArticle.notFound
  };
}

export default connect(mapStateToProps, { loadKbArticle })(KbArticlePage);
